"use client";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Feedback from "react-bootstrap/Feedback";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import FormLabel from "react-bootstrap/FormLabel";
import FormText from "react-bootstrap/FormText";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";

export default () => {
  const [validated, setValidated] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  const handleCloseRegisterModal = () => setShowRegisterModal(false);
  const handleOpenRegisterModal = () => setShowRegisterModal(true);

  const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~`!@#$%^&*()_\-+={\[}\]|\\:;"'<,>.?/]).{8,}$/;

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true)
  }

  return (
    <span>
      <a href="#" onClick={handleOpenRegisterModal}>Sign up!</a>
      <Modal show={showRegisterModal} onHide={handleCloseRegisterModal}>
        <ModalHeader closeButton>
          <ModalTitle>Create an Account</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Form noValidate validated={validated} onSubmit={handleSubmit} action="/login/registerlocal" encType="multipart/form-data" method="post">
            <FormGroup className="mb-3" controlId="email">
              <FormLabel>Email</FormLabel>
              <FormControl
                required
                type="email"
                placeholder="Email"
                name="email"
              />
              <Feedback type="invalid">You must enter an email.</Feedback>
            </FormGroup>
            <FormGroup className="mb-3" controlId="password">
              <FormLabel>Password</FormLabel>
              <FormControl
                required
                type="password"
                placeholder="Password"
                name="password"
                pattern={passwordRegex.source}
                onChange={(event) => setPassword(event.target.value)}
                aria-describedby="passwordHelp"
              />
              <FormText id="passwordHelp" muted>
                Passwords must be at least 8 characters and must contain at least 1 uppercase
                letter, lowercase letter, number, and symbol.
              </FormText>
              <Feedback type="invalid">
                Please enter a valid password.
              </Feedback>
            </FormGroup>
            <FormGroup className="mb-3" controlId="confirmPassword">
              <FormLabel>Confirm Password</FormLabel>
              <FormControl
                required
                type="password"
                placeholder="Confirm Password"
                name="confirmPassword"
                pattern={passwordRegex.source}
                isValid={password !== "" && password === confirmPassword}
                isInvalid={password !== "" && password !== confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
              />
              <Feedback type="invalid">
                Passwords must match!
              </Feedback>
            </FormGroup>
            <FormGroup className="mb-3" controlId="firstName">
              <FormLabel>First Name</FormLabel>
              <FormControl
                required
                type="text"
                placeholder="George"
                name="firstName"
              />
              <Feedback type="invalid">Please provide your first name.</Feedback>
            </FormGroup>
            <FormGroup className="mb-3" controlId="lastName">
              <FormLabel>Last Name</FormLabel>
              <FormControl
                required
                type="text"
                placeholder="Burdell"
                name="lastName"
              />
              <Feedback type="invalid">Please provide your last name.</Feedback>
            </FormGroup>
            <FormGroup className="mb-3" controlId="affiliation">
              <FormLabel>Institute/Company Affiliation</FormLabel>
              <FormControl
                required
                type="text"
                placeholder="Georgia Tech"
                name="affiliation"
              />
              <Feedback type="invalid">
                Please provide the institute or company you are affiliated with.
              </Feedback>
            </FormGroup>
            <Button type="submit" className="w-100">Register</Button>
          </Form>
        </ModalBody>
      </Modal>
    </span>
  )
}